module.exports = __webpack_public_path__ + "img/icon-arrow-top-right-green.c37738e3.svg";